/* eslint-disable */
// GENERATED by scripts/gen-severity.js from saf3ai-auth-sdk/src/saf3ai_auth/catalog/severity.yaml
// Do not edit by hand: run `node scripts/gen-severity.js` after the SDK scale changes.
//
// The platform's one severity scale. Read it through src/severity, never directly.

const SEVERITY_DEFINITION = {
  "version": 1,
  "levels": {
    "critical": {
      "rank": 4,
      "label": "Critical",
      "meaning": "Harm happened or is imminent, or a control was bypassed - CSAM, weapons or malware content, a confirmed successful jailbreak, secrets or regulated data (health, card, government ID) leaving.",
      "response": "Respond now; pages on-call."
    },
    "high": {
      "rank": 3,
      "label": "High",
      "meaning": "A serious policy breach or a likely attack - a prompt-injection or jailbreak attempt, hate or harassment, sexual content, a malicious URL, personal data exposed.",
      "response": "Same day."
    },
    "medium": {
      "rank": 2,
      "label": "Medium",
      "meaning": "Policy-relevant risk that needs review - internal or confidential data, intellectual property, elections, specialised advice, risky intent, posture drift.",
      "response": "Review this week."
    },
    "low": {
      "rank": 1,
      "label": "Low",
      "meaning": "Hygiene - a weakness with no direct harm.",
      "response": "Backlog."
    },
    "info": {
      "rank": 0,
      "label": "Info",
      "meaning": "A recorded fact, not a finding. Never counted as one.",
      "response": "None."
    }
  },
  "states": {
    "none": {
      "label": "None",
      "meaning": "Checked - nothing found."
    },
    "unknown": {
      "label": "Unknown",
      "meaning": "Not graded",
      "or a value this scale does not recognise.": null
    }
  },
  "aliases": {
    "informational": "info",
    "information": "info",
    "minimal": "info",
    "notice": "info",
    "note": "low",
    "warning": "medium",
    "warn": "medium",
    "moderate": "medium",
    "error": "high",
    "severe": "critical",
    "clean": "none",
    "pass": "none",
    "passed": "none",
    "safe": "none",
    "n/a": "unknown",
    "": "unknown"
  },
  "numeric_1_5": {
    "1": "info",
    "2": "low",
    "3": "medium",
    "4": "high",
    "5": "critical"
  },
  "risk_score_bands": [
    {
      "min": 80,
      "level": "critical"
    },
    {
      "min": 60,
      "level": "high"
    },
    {
      "min": 40,
      "level": "medium"
    },
    {
      "min": 0.000001,
      "level": "low"
    }
  ],
  "cvss_bands": [
    {
      "min": 9,
      "level": "critical"
    },
    {
      "min": 7,
      "level": "high"
    },
    {
      "min": 4,
      "level": "medium"
    },
    {
      "min": 0.1,
      "level": "low"
    }
  ],
  "health_bands": {
    "compliance": [
      {
        "min": 90,
        "status": "good",
        "label": "Compliant"
      },
      {
        "min": 70,
        "status": "fair",
        "label": "Partially compliant"
      },
      {
        "min": 0,
        "status": "poor",
        "label": "Non-compliant"
      }
    ],
    "posture": [
      {
        "min": 80,
        "status": "good",
        "label": "Healthy"
      },
      {
        "min": 60,
        "status": "fair",
        "label": "Fair"
      },
      {
        "min": 40,
        "status": "poor",
        "label": "Elevated risk"
      },
      {
        "min": 0,
        "status": "bad",
        "label": "Critical risk"
      }
    ]
  },
  "detections": {
    "critical": [
      "CSAM",
      "child_sexual_exploitation",
      "Dangerous",
      "indiscriminate_weapons",
      "weapons_explosives",
      "violent_crimes",
      "ViolentCrimes",
      "suicide_self_harm",
      "SuicideSelfHarm",
      "MalwareDetection",
      "malware_cyber_abuse",
      "code_execution",
      "shell_command",
      "path_traversal",
      "credential_access"
    ],
    "high": [
      "PIandJailbreak",
      "pi_and_jailbreak",
      "PromptInjection",
      "jailbreak",
      "HateSpeech",
      "hate",
      "Harassment",
      "SexualExplicit",
      "SexuallyExplicit",
      "sexual_content",
      "sex_related_crimes",
      "MaliciousURIs",
      "non_violent_crimes",
      "NonViolentCrimes",
      "code_interpreter_abuse",
      "ExcessiveAgency",
      "Violence",
      "data_exfiltration",
      "ModelTheft",
      "TrainingDataPoisoning"
    ],
    "medium": [
      "elections",
      "IntellectualProperty",
      "intellectual_property",
      "specialized_advice",
      "defamation",
      "Defamation",
      "Toxicity",
      "Overreliance",
      "ModelDoS",
      "customer_data",
      "OutOfBounds"
    ],
    "by_data_class": [
      "SensitiveData",
      "SenstiveData",
      "privacy",
      "pii"
    ],
    "low": []
  },
  "confirmable": [
    "PIandJailbreak",
    "pi_and_jailbreak",
    "PromptInjection",
    "jailbreak"
  ],
  "data_classes": {
    "critical": [
      "PRIVATE_KEY",
      "JWT_TOKEN",
      "BEARER_TOKEN",
      "DATABASE_URL",
      "MONGODB_URI",
      "API_KEY",
      "OPENAI_API_KEY",
      "GITHUB_TOKEN",
      "GITHUB_OAUTH",
      "AWS_ACCESS_KEY",
      "AWS_SECRET_KEY",
      "GCP_SERVICE_ACCOUNT_KEY",
      "GCP_API_KEY",
      "AZURE_CLIENT_SECRET",
      "AZURE_STORAGE_KEY",
      "SLACK_TOKEN",
      "DISCORD_TOKEN",
      "STRIPE_KEY",
      "TWILIO_KEY",
      "PASSWORD",
      "CREDENTIAL",
      "SECRET",
      "CREDIT_CARD",
      "AADHAAR",
      "AADHAAR_NUMBER",
      "SSN",
      "US_SSN",
      "PAN",
      "PAN_NUMBER",
      "PASSPORT",
      "PASSPORT_NUMBER",
      "PASSPORT_IN",
      "US_PASSPORT",
      "DRIVER_LICENSE",
      "DRIVING_LICENSE_IN",
      "US_DRIVER_LICENSE",
      "TAX_ID",
      "VOTER_ID",
      "MEDICAL_RECORD",
      "MEDICAL_LICENSE",
      "UK_NHS",
      "IBAN_CODE",
      "US_BANK_NUMBER",
      "BANK_ACCOUNT_IN",
      "BANK_ACCOUNT_NUMBER",
      "PCI",
      "PHI",
      "CREDENTIALS",
      "SECRETS"
    ],
    "high": [
      "PERSON",
      "NAME",
      "EMAIL",
      "EMAIL_ADDRESS",
      "PHONE",
      "PHONE_NUMBER",
      "MOBILE_IN",
      "IP_ADDRESS",
      "DATE_OF_BIRTH",
      "LOCATION",
      "ADDRESS",
      "USERNAME",
      "UPI_ID",
      "GSTIN"
    ],
    "medium": [
      "CONFIDENTIAL",
      "INTERNAL",
      "LEGAL_PRIVILEGE",
      "CONTRACT_LANGUAGE",
      "SOURCE_CODE",
      "IFSC",
      "IFSC_CODE"
    ]
  },
  "colors": {
    "critical": "#EF4444",
    "high": "#F97316",
    "medium": "#EAB308",
    "low": "#3B82F6",
    "info": "#64748B",
    "none": "#22C55E",
    "unknown": "#94A3B8"
  },
  "outbound": {
    "pagerduty": {
      "critical": "critical",
      "high": "error",
      "medium": "warning",
      "low": "info",
      "info": "info"
    },
    "opsgenie": {
      "critical": "P1",
      "high": "P2",
      "medium": "P3",
      "low": "P4",
      "info": "P5"
    },
    "jira": {
      "critical": "Highest",
      "high": "High",
      "medium": "Medium",
      "low": "Low",
      "info": "Lowest"
    }
  }
};

export default SEVERITY_DEFINITION;
